import { createFileRoute } from "@tanstack/react-router";
import HVACServicesOverview from "@/pages/HVACServicesOverview";
import { hubHead } from "@/lib/route-seo";

export const Route = createFileRoute("/hvac-services/")({
  head: () => hubHead("/hvac-services"),
  component: HVACServicesOverview,
});
